export async function acceptRequest({ token, roomId, peerId }, socket) {
  await socket.request('acceptRequest', { roomId, peerId });
}

export async function denyRequest({ token, roomId, peerId }, socket) {
  await socket.request('denyRequest', { roomId, peerId });
}
